angular.module('natura').filter('pggTrueFalseFilter', [function() {
  return function(condition) {
    if (condition === true) {
      return 'igen';
    } else if (condition === false) {
      return 'nem';
    } else if (condition === null) {
      return null;
    }
  };
}]);
